// removed by extract-text-webpack-plugin
module.exports = {"btnsWrapper":"index__btnsWrapper___3Oiiw","floatBtn":"index__floatBtn___3_32F","maxTip":"index__maxTip___JhVXA"};


//////////////////
// WEBPACK FOOTER
// ./src/views/DashboardSettings_Details/index.less
// module id = 659
// module chunks = 3